import { useCallback, useMemo, useRef } from "react";

import { AgGridOverlay } from "@src/components/overlays/ag_grid_overlay";
import { useGetResourcePlanChangelogQuery } from "@src/services/slices/resourcePlanApi";
import { ChangelogTableItem } from "@src/types/resource_plan_types";
import {
  GridOptions,
  ICellRendererParams,
  IDetailCellRendererParams,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import "./changelog_tab.less";
import { useParams } from "react-router-dom";

import {
  getChangelogGridOptions,
  getDetailCellRendererParams,
} from "../../utils/changelog_grid_options";
import { mapChangelogDataToTableData } from "../../utils/changelog_utils";
import { ChangelogTabToolBar } from "../changelog_tab_tool_bar";

const ChangelogTab: React.FC = () => {
  const gridRef = useRef<AgGridReact>(null);
  const { id } = useParams();

  const { data: changeLogData, isFetching } =
    useGetResourcePlanChangelogQuery(id);

  const changelogTableData = useMemo<ChangelogTableItem[]>(() => {
    return mapChangelogDataToTableData(changeLogData);
  }, [changeLogData]);

  const gridOptions = useMemo<GridOptions>(() => {
    return getChangelogGridOptions();
  }, []);

  const detailCellRendererParams = useMemo<
    (params: ICellRendererParams) => IDetailCellRendererParams
  >(() => {
    return (params: ICellRendererParams) => getDetailCellRendererParams(params);
  }, []);

  const onQuickFilter = useCallback((searchInput: string) => {
    gridRef?.current.api?.setGridOption("quickFilterText", searchInput);
  }, []);

  return (
    <div className="changelog-tab">
      <ChangelogTabToolBar
        onQuickFilter={onQuickFilter}
        disabled={isFetching}
      />
      <AgGridReact
        ref={gridRef}
        rowData={changelogTableData}
        gridOptions={gridOptions}
        noRowsOverlayComponent={AgGridOverlay}
        noRowsOverlayComponentParams={{
          text: "No changelog history found",
          customStyle: { marginTop: "48px" },
        }}
        loadingOverlayComponent={AgGridOverlay}
        loadingOverlayComponentParams={{
          text: "Loading changelog history...",
          customStyle: { marginTop: "48px" },
        }}
        loading={isFetching}
        masterDetail={true}
        detailRowAutoHeight={true}
        detailCellRendererParams={detailCellRendererParams}
      />
    </div>
  );
};

export default ChangelogTab;
